import { render, staticRenderFns } from "./stagestep3.vue?vue&type=template&id=71c5769a&"
import script from "./stagestep3.vue?vue&type=script&lang=js&"
export * from "./stagestep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports